import { render, staticRenderFns } from "./new-show.vue?vue&type=template&id=6b7cb6bf&scoped=true&"
import script from "./new-show.vue?vue&type=script&lang=js&"
export * from "./new-show.vue?vue&type=script&lang=js&"
import style0 from "./new-show.vue?vue&type=style&index=0&id=6b7cb6bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7cb6bf",
  null
  
)

export default component.exports